export default "__VITE_ASSET__Bx$9sn27__"